<template>
  <div class="wrapper">
    <div class="container text-left mb-5">
      <div class="header">
        <img
          class="anx-logo"
          src="@/assets/Anexia-PeeringPortal-white.svg"
        >
      </div>
      <p>
        Use this form to request a network peering with Anexia (AS42473, AS47147) in any public exchange point of mutual presence. To retrieve the available options fill in your AS number, the form will then be auto-populated using the data from <a href="https://peeringdb.com">peeringdb.com</a>.
        After updating your PeeringDB data please allow some time for the application to pick up any changes made.
      </p>
    </div>
    <PeeringForm />
  </div>
</template>

<script>
import PeeringForm from "@/components/PeeringForm.vue";

export default {
  name: "Peering",
  components: {
    PeeringForm
  }
};
</script>

<style lang="scss" scoped>
.header {
  margin-top: 60px;
  margin-bottom: 30px;
}

p{
  margin-bottom: 30px;
}
.anx-logo {
  height: 45px;
  left: 0px;
}
</style>
